/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateBulkInviteFromFileBackofficePayload,
  InviteResponseV2Dto,
  VerifyInviteParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInviteV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invite-v-2-controller
   * @name CreateBulkInviteFromFileBackoffice
   * @request POST:/api/v2/invite/bulk/csv-file-upload/backoffice/{organisationId}
   */
  createBulkInviteFromFileBackoffice = (
    organisationId: string,
    data: CreateBulkInviteFromFileBackofficePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/invite/bulk/csv-file-upload/backoffice/${organisationId}`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      ...params,
    })

  static createBulkInviteFromFileBackofficePath =
    '/v2/invite/bulk/csv-file-upload/backoffice/${organisationId}'
  static createBulkInviteFromFileBackofficeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-v-2-controller
   * @name GetAll1
   * @request GET:/api/v2/invite
   */
  getAll = (params: RequestParams = {}) =>
    this.http.request<InviteResponseV2Dto[], any>({
      path: `/v2/invite`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllPath = '/v2/invite'
  static getAllMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invite-v-2-controller
   * @name VerifyInvite
   * @request GET:/api/v2/invite/{organisationId}/{token}/verify
   */
  verifyInvite = (
    { organisationId, token, ...query }: VerifyInviteParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InviteResponseV2Dto, any>({
      path: `/v2/invite/${organisationId}/${token}/verify`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static verifyInvitePath = '/v2/invite/${organisationId}/${token}/verify'
  static verifyInviteMethod = 'GET'
}
